import { render, staticRenderFns } from "./metainfo.vue?vue&type=template&id=4b8f0ca6"
import script from "./metainfo.vue?vue&type=script&lang=js"
export * from "./metainfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports